"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentAsFactory = ComponentAsFactory;
exports.bind = bind;
exports.runInBackground = runInBackground;
exports.asyncBind = asyncBind;
exports.assertDefined = assertDefined;
exports.normalizeArray = normalizeArray;
exports.assertKeys = assertKeys;
exports.isArray = isArray;
exports.isObject = isObject;
exports.isEqualArray = isEqualArray;
exports.isEqualObject = isEqualObject;
exports.reverse = reverse;
const react_1 = __importDefault(require("react"));
function freeParamize(args) {
    let params = {};
    let contents = [];
    args.forEach((arg) => {
        if (arg === null)
            return;
        if (typeof arg == "object") {
            if (react_1.default.isValidElement(arg))
                contents.push(arg);
            else
                Object.assign(params, arg);
        }
        else
            contents.push(arg);
    });
    return {
        params: params,
        contents: contents,
    };
}
function ComponentAsFactory(name, predefinedParams = {}) {
    return function (...args) {
        let { params, contents } = freeParamize(args);
        return react_1.default.createElement(name, Object.assign({}, predefinedParams, params), ...contents);
    };
}
function bind(context, ...functions) {
    for (let a = 0; a < functions.length; a++) {
        context[functions[a].name] = functions[a].bind(context);
    }
}
/// runs task in the background
function runInBackground(callback) {
    setTimeout(function () {
        callback();
    }, 0);
}
/**
 * Async function factory
 *
 * @param {function} callback
 * @param {object} context
 */
function asyncBind(callback, context = null) {
    return runInBackground.bind(context, callback);
}
function assertDefined(obj, type = null) {
    return obj;
}
/// make arr an 1 element array if it is not already
function normalizeArray(arr) {
    if (arr === undefined)
        return [];
    if (!(arr instanceof Array))
        return [arr];
    return arr;
}
function assertKeys(object, ...keys) {
    let missing = [];
    keys.forEach((key) => {
        if (!object.hasOwnProperty(key))
            missing.push(key);
    });
    if (missing.length)
        throw new Error(`Missing key(s) from object: ${missing.join(", ")}`);
    return object;
}
/// returns true if o is an array
function isArray(o) {
    return o && o.constructor === Array;
}
/// returns true if o is an object
function isObject(o) {
    return o && o.constructor === Object;
}
/// returns true if a and b are equal
function isEqualArray(a, b, recursive = false, seen = []) {
    if (a.length !== b.length)
        return false;
    for (let i = 0; i < a.length; i++) {
        if (seen.indexOf(a[i] === -1)) {
            seen.push(a[i]);
            if (isArray(a[i]) && isArray(b[i])) {
                if (!isEqualArray(a[i], b[i], recursive, seen))
                    return false;
            }
            else if (typeof a[i] == typeof b[i] && typeof a[i] == "object") {
                if (!isEqualObject(a[i], b[i], recursive, seen))
                    return false;
            }
            else {
                if (a[i] !== b[i])
                    return false;
            }
        }
    }
    return true;
}
function isEqualObjectKeys(a, b) {
    if (a === null && b === null)
        return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (!isEqualArray(aKeys, bKeys, false))
        return false;
    return true;
}
function isEqualObject(a, b, recursive = false, seen = []) {
    if (!isObject(a) || !isObject(b))
        return false;
    if (typeof a != typeof b || typeof a != "object")
        return false;
    if (!isEqualObjectKeys(a, b))
        return false;
    for (let name in a) {
        if (recursive) {
            if (seen.indexOf(a[name]) === -1) {
                seen.push(a[name]);
                if (a[name] instanceof Array && b[name] instanceof Array) {
                    if (isEqualArray(a[name], b[name], recursive, seen))
                        continue;
                    else
                        return false;
                }
                else if (isObject(a[name]) && isObject(b[name])) {
                    if (isEqualObject(a[name], b[name], recursive, seen))
                        continue;
                    else
                        return false;
                }
            }
        }
        if (a[name] !== b[name])
            return false;
    }
    return true;
}
function* reverse(array) {
    if (!isArray(array))
        throw new Error("Variable is not array!: " + JSON.stringify(array));
    for (let i = array.length - 1; i >= 0; i--) {
        yield array[i];
    }
}
//# sourceMappingURL=tools.js.map